import { ResumoGeral } from "./CaixaPage";

export const resumoMock: ResumoGeral = {
  sessao: {
    id: 4440607,
    status: "ABERTO",
    abertoEm: new Date("2026-02-14T19:54:00"),
    valor: 549.22
  },
  resumoCaixa: {
    saldoInicial: 500.0,
    suprimentos: 200.0,
    sangrias: 150.0,
    vendasDinheiro: 45.5,
    vendasDinheiroIfood: 0.0,
    recebimentosFiadoDinheiro: 0.0,
    valorEmCaixa: 595.5
  },
  resumoVendas: {
    ifood: {
      pix: 261.96,
      visa: 58.99,
      mastercard: 56.49,
      nubank: 40.99,
      total: 539.0,
      taxasEntrega: 51.5,
      taxasAdicionais: 8.92,
      descontos: -50.0
    },
    pagamentosOffline: {
      creditoMastercard: 90.99
    },
    infosAdicionais: {
      valorProdutos: 539.00,
      taxasEntrega: 51.50,
      taxasAdicionais: 8.92
    }
  },
  totalGeral: 549.42
};

export type TipoMovimentacao = "Abertura" | "Venda" | "Suprimento" | "Sangria";
export type FormaPagamento = "Dinheiro" | "Débito" | "Crédito";

export interface CaixaMovimentacao {
  id: number;
  data_hora: Date;
  descricao: string;
  valor: number;
  forma_pagamento: FormaPagamento;
  tipo: TipoMovimentacao;
  usuario: string;
}

export const mockCaixaMovimentacoes: CaixaMovimentacao[] = [
  {
    id: 1,
    data_hora: new Date("2026-02-15T08:00:00"),
    descricao: "Saldo inicial",
    valor: 500.0,
    forma_pagamento: "Dinheiro",
    tipo: "Abertura",
    usuario: "Sistema",
  },
  {
    id: 2,
    data_hora: new Date("2026-02-15T08:15:00"),
    descricao: "Venda - Pedido #001",
    valor: 45.5,
    forma_pagamento: "Dinheiro",
    tipo: "Venda",
    usuario: "João Silva",
  },
  {
    id: 3,
    data_hora: new Date("2026-02-15T08:30:00"),
    descricao: "Venda - Pedido #002",
    valor: 120.0,
    forma_pagamento: "Débito",
    tipo: "Venda",
    usuario: "João Silva",
  },
  {
    id: 4,
    data_hora: new Date("2026-02-15T09:00:00"),
    descricao: "Suprimento",
    valor: 200.0,
    forma_pagamento: "Dinheiro",
    tipo: "Suprimento",
    usuario: "Gerente",
  },
  {
    id: 5,
    data_hora: new Date("2026-02-15T09:30:00"),
    descricao: "Sangria",
    valor: -150.0,
    forma_pagamento: "Dinheiro",
    tipo: "Sangria",
    usuario: "Gerente",
  },
  {
    id: 6,
    data_hora: new Date("2026-02-15T10:00:00"),
    descricao: "Venda - Pedido #003",
    valor: 89.9,
    forma_pagamento: "Crédito",
    tipo: "Venda",
    usuario: "Maria Santos",
  },
];